import React from 'react'
import { ToggleEntries } from '../../../../../helpers/commonUi'
import { useCreateFunction, toggleImport } from '../CreateFunctionContext'
import { clientSideImports } from '../constants'

export const Imports = () => {
  const { state, dispatch } = useCreateFunction()
  const entries =
    state.executionMode === 'server'
      ? state.imports
      : state.imports
          .filter(entry => clientSideImports.includes(entry.name))
          .map((el) => ({ ...el, isChecked: true }))

  const handleToggle = (idx: number) => {
    dispatch(toggleImport(idx))
  }

  return (
    <ToggleEntries
      title="Imports"
      entries={entries}
      handleToggle={handleToggle}
      disableToggle={state.executionMode === 'client'}
    />
  )
}
